import { FC, useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { EmailTemplate, MessagesDisplayContainer } from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  landingMessagesAtom,
  NvidiaShuttleLoginStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepLoginNvidiaShuttle } from "./use-step-login.nvidiashuttle";

export const StepLoginNvidiaShuttle: FC = () => {
  const { methods, handleLogin, isContinueCanBeApply } =
    useStepLoginNvidiaShuttle();
  const [searchParams, setSearchParams] = useSearchParams();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();

  useEffect(() => {
    if (searchParams) {
      setSearchParams("");
    }
  }, [searchParams, setSearchParams]);

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <h1 className="landing-title">
          {t("landing.login.title")}
          <br />
          {t("landing.login.subTitle")}
        </h1>

        <div className="landing-form-field landing-form-field__email">
          <label htmlFor={NvidiaShuttleLoginStepFormFieldsEnum.Email}>
            {t("landing.formLabel.email")}*
          </label>
          <EmailTemplate
            uniqueAttrId={NvidiaShuttleLoginStepFormFieldsEnum.Email}
            name={NvidiaShuttleLoginStepFormFieldsEnum.Email}
          />
        </div>

        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />

        <ContinueButton
          loading={isApiLoading}
          disabled={!isContinueCanBeApply}
          onClick={handleLogin}
        />

        <div className="landing-container-footer">
          <div className="landing-container-footer-logo">
            <img
              className="landing-logo__img"
              src={RASTER_LANDINGS.RideLogoPNG}
              alt="Ryde logo"
              width="120"
              height="51"
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
